'use strict';

class BillingTableController {
  constructor($scope, $timeout, $filter, billingService) {
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$filter = $filter;
    this.billingService = billingService;
  }
  $onInit() {
    this.viewVisible = false;
    this.number = this.number || 0;
    this.title = this.title || '';
    this.showInvoices = this.showInvoices || false;
  }

  actions($event) {
    if (this.viewVisible) {
      if ($event.keyCode === 27) {
        this.closeView();
      }
    }
  }

  closeView() {
    let modal = document.querySelector('.preview-modal');
    modal.style.display = 'none';
    this.viewVisible = false;
  }

  getLink(documentType, number, dunningType) {
    switch (documentType) {
      case 'INVOICE' :
        return '#/regning/' + number;
      case 'CREDIT' :
        return '#/kreditnota/' + number;
      case 'OFFER' :
        return '#/tilbud/' + number;
      case 'ORDER_CONFIRMATION' :
        return '#/ordrebekreftelse/' + number;
      case 'DUNNING' :
        return '#/purring/' + number + '?type=' + dunningType;
      default:
        return documentType;
    }
  }

  translate(documentType) {
    switch (documentType) {
        case 'INVOICE' :
          return 'Regning';
        case 'CREDIT' :
          return 'Kreditnota';
        case 'OFFER' :
          return 'Tilbud';
        case 'ORDER_CONFIRMATION' :
          return 'Ordrebekreftelse';
        case 'DUNNING' :
          return 'Purring';
        default:
          return documentType;
      }
  }

  getInvoices(billNumber) {
      this.billingService.getByBill(billNumber)
        .then((resp) => {
          if (resp.data && resp.data.length > 0) {
            this.billedInvoices = resp.data;

            let modal = document.querySelector('.preview-modal');
            // let modal = document.getElementById(this.modalId);
            modal.style.display = 'block';
            // $('.billingModalContent').eq(this.number).html('invoices ' + resp.data.length);
            let html = '<H2>Fakturerte dokumenter</H2><table>';
            html += '<thead><tr><th>Type</th><th>Nummer</th><th>Dato</th><th>Mottager</th></thead>';
            this.billedInvoices.forEach((item) => {
              html += '<tbody><tr>';
              html += '<td>' + this.translate(item.documentType) + '</td>';
              html += '<td><a href="' + this.getLink(item.documentType, item.number, item.dunningType) + '">' + item.number + '</a></td>';
              html += '<td>' + item.date + '</td>';
              html += '<td>' + item.recipientName + '</td>';
              html += '</tr></tbody>';
            });
            html += '</table>';

            $('.billingModalContent').eq(this.number).html(html);

            this.viewVisible = true;
          }
        });
    }
  }

BillingTableController.$inject = ['$scope', '$timeout', '$filter', 'billingService'];

const billingTable = {
  bindings: {
    title: '<',
    header: '<',
    items: '<',
    summary: '<',
    number: '<',
    showInvoices: '<'
  },
  controller: BillingTableController,
  template: `
    <div id="$ctrl.modalId" class="preview-modal" ng-show="$ctrl.viewVisible" style="display: block; overflow:scroll; z-index: 100;">
      <div class="preview-modal-content" style=" width:50%">
        <span class="close-btn" ng-click="$ctrl.closeView()">
          <i class="fa fa-times fa-lg" ng-click="$ctrl.closeView()"></i>
        </span>
        <div class="billingModalContent"></div>
      </div>
    </div>

    <h2 ng-if="$ctrl.title">{{ $ctrl.title }}</h2>

    <h4 ng-if="$ctrl.header">{{ $ctrl.header }}</h4>

    <input type="search" ng-model="$ctrl.q" placeholder="Søk på fakturanummer">

    <table>
      <thead>
        <tr>
          <th>Regning</th>
          <th>Dato</th>
          <th>Forfallsdato</th>
          <th class="right-align">Opprinnelig beløp</th>
          <th class="right-align">Gebyr/Renter</th>
          <th class="right-align">Allerede betalt</th>
          <th class="right-align nowrap">Utestående</th>
          <th ng-show="$ctrl.showInvoices" class="right-align nowrap"></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="item in $ctrl.items | filter:$ctrl.q track by $index">
          <td>
            <a ng-hide="item._links.dunnings.length" href="{{ item._links.invoice.pdf }}">{{ item.invoiceNumber }}</a>

            <a ng-show="item._links.dunnings.length" href ng-click="panel = !panel">{{ item.invoiceNumber }}</a>
            <ul ng-show="panel" class="dropdown-list">
              <li><a href="{{ item._links.invoice.pdf }}">Regning</a></li>
              <li ng-repeat="dunning in item._links.dunnings"><a href="{{ dunning.pdf }}">{{ dunning.type | documentName }}</a></li>
            </ul>
          </td>
          <td>{{ item.invoiceDate | dateFormat }}</td>
          <td>{{ item.dueDate | dateFormat }}</td>
          <td class="right-align">{{ item.total | crowns }}</td>
          <td class="right-align">{{ item.feesAndInterest | crowns }}</td>
          <td class="right-align">{{ item.paid | crowns }}</td>
          <td class="right-align nowrap">{{ item.balance | crowns }}</td>
          <td ng-show="$ctrl.showInvoices" class="right-align nowrap"><a href ng-click="$ctrl.getInvoices(item.invoiceNumber)"><i class="fa fa-eye"></i></a></td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="3">Total</th>
          <th class="right-align">{{ $ctrl.summary.total | crowns }}</th>
          <th class="right-align">{{ $ctrl.summary.feesAndInterest | crowns }}</th>
          <th class="right-align">{{ $ctrl.summary.paid | crowns }}</th>
          <th class="right-align nowrap">{{ $ctrl.summary.balance | crowns }}</th>
          <th ng-show="$ctrl.showInvoices" class="right-align nowrap"></th>
        </tr>
      </tfoot>
    </table>
  `
};

angular
  .module('SendRegning')
  .component('billingTable', billingTable);
